<template>
    <div class="no-result">
        <img :src="src">
        <p>{{text}}</p>
    </div>
</template>
<script>
    export default{
        data(){
            return {}
        },
        props:{
            src:{
                type:String
            },
            text:{
                type:String
            }
        }
    }
</script>
<style scoped type="text/scss" lang="scss">
    .no-result {
        text-align: center;
        padding-top: 130px;
    }

    .no-result img {
        width: 118px;
    }

    .no-result p {
        font-size: 14px;
        color: #A2A2A8;
        margin-top: 20px;
    }
</style>
